<template>
  <div class="w-table" :class="{ 'w-table_moving': dragState.dragging }">
    <template v-if="showTableHeader">
      <div class="chart-header">
        <div class="module-name" v-if="showModuleName">{{ moduleName }}</div>
        <div class="sub-title" v-if="showSubTitle">{{ subTitle }}</div>
      </div>
      <chart-filter-conditions
        :tableConditions="tableConditions"
        :tableHeader="tableHeader"
        @search="search"
      />
    </template>
    <transition name="el-fade-in-linear">
      <el-table
        v-show="tableHeader.length"
        v-loading="isloading"
        :data="tableData"
        :border="option.border"
        :height="option.height"
        :max-height="550"
        :style="{ width: parseInt(option.width) + 'px' }"
        :cell-class-name="cellClassName"
        :header-cell-class-name="headerCellClassName"
        :default-sort="{ prop: 'num', order: 'descending' }"
        ref="hmtable"
        :row-style="{ height: '44px' }"
        :cell-style="{ padding: '0px' }"
        stripe
      >
        <slot name="fixed"></slot>
        <template slot="empty">
            <div class="flex flex-between">
              <p class="emptyText">暂无数据</p>
              <p class="emptyText">暂无数据</p>
              <p class="emptyText">暂无数据</p>
            </div>
        </template>
        <el-table-column
          v-if="col.isShow"
          v-for="(col, index) in tableHeader"
          :key="index"
          min-width="200px"
          :prop="col.columnName"
          :label="col.labelName"
          :type="col.type"
          :header-align="col.headerAlign"
          :column-key="index.toString()"
          :render-header="renderHeader"
          :fixed="col.fixed"
          show-overflow-tooltip
        >
          <!--  -->
          <!-- :render-header="renderHeader" -->
          <template slot-scope="scope" slot="header">
            <div
              class="thead-cell"
              @mousedown="handleMouseDown(scope.row, col)"
              @mousemove="handleMouseMove(scope.row, col)"
            >
              <span> {{ col.labelName }}</span>
              <span class="virtual"></span>
              <!-- <span
                class="hmicon icon-guanbi1 pointer delete-tab"
                @click="del(scope.row, col)"
              ></span> -->
              <!-- <el-select v-model="value" placeholder="请选择">
                <el-option
                  v-for="item in s_options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select> -->
            </div>
          </template>
          <!-- <div class="table_options">
            <span>表头配置</span>
            <span>></span>
          </div> -->
        </el-table-column>
      </el-table>
    </transition>
  </div>
</template>

<script>
import chartFilterConditions from "@/components/charts/chartFilterConditions";
export default {
  props: {
    data: {
      default: function () {
        return [];
      },
      type: Array,
    },
    header: {
      default: function () {
        return [];
      },
      type: Array,
    },
    xiaoji: {
      default: function () {
        return [];
      },
      type: Array,
    },
    option: {
      default: function () {
        return {};
      },
      type: Object,
    },
    disableDeleteBtn: {
      type: Boolean,
      default: false,
    },
    tableConditions: {
      type: Array,
      default: () => [],
    },
    showTableHeader: {
      type: Boolean,
      default: false,
    },
    moduleName: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
    showModuleName: {
      type: Boolean,
      default: true,
    },
    showSubTitle: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    chartFilterConditions,
  },
  data() {
    return {
      falg: false,
      seach: "",
      isloading: this.loading,
      tableHeader: this.header,
      tableData: JSON.parse(JSON.stringify(this.data)),
      dragState: {
        start: -9, // 起始元素的 index
        end: -9, // 移动鼠标时所覆盖的元素 index
        dragging: false, // 是否正在拖动
        direction: undefined, // 拖动方向
      },
      hmtable: this.$refs.hmtable,
      transitionShow: true,
      s_option: [
        {
          lable: "固定到左边",
          value: "fixed-left",
        },
        {
          lable: "固定到右边",
          value: "fixed-right",
        },
      ],
      s_value: "",
      tableXiaoji: this.xiaoji,
      xiaojiFlag: false,
      tableRawData: JSON.parse(JSON.stringify(this.data)),
    };
  },
  computed: {},
  watch: {
    header(val) {
      // if (this.tableHeader.length !== val.length) {
      //   val.forEach((el, idx, arr) => {
      //     arr[idx].isShow = true;
      //   });
      //   this.tableHeader = val;
      //   console.log("this.tableHeader111: ", this.tableHeader);
      //   this.transitionShowTiem();
      // }
      this.tableHeader = val;
      console.log("this.tableHeader: ", this.tableHeader);
      this.transitionShowTiem();

      this.hmtable = this.$refs.hmtable;
    },
    xiaoji(val) {
      this.tableXiaoji = val;
    },
    loading(val) {
      this.isloading = val;
    },
    data(val) {
      val.forEach((v) => {
        for (let key in v) {
          this.tableHeader.forEach((o) => {
            if (o.columnName === key && o.associatedDictCode !== "") {
              v[key] = this.translation(o.associatedDictCode, v[key]);
            }
          });
        }
      });
      this.tableData = JSON.parse(JSON.stringify(val));
      this.tableRawData = JSON.parse(JSON.stringify(val));
      this.$nextTick(() => {
        //解决表头与内容错位
        this.$refs.hmtable.doLayout();
      });
    },
  },
  created() {},

  mounted() {
    this.transitionShow = false;
  },
  methods: {
    transitionShowTiem() {
      this.transitionShow = false;
      // setTimeout(() => {
      //   this.tableHeader = val;
      // }, 3000);
      setTimeout(() => {
        this.transitionShow = true;
      }, 800);
    },
    getTable() {
      return this.$refs.hmtable;
    },
    translation(code, columnName) {
      if (columnName) {
        if (this.$sysAllDict[code].find((o) => o.value === columnName)) {
          return this.$sysAllDict[code].find((o) => o.value === columnName)
            .text;
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    headerCellClassName({ columnIndex }) {
      let active =
        columnIndex - 1 === this.dragState.end
          ? `darg_active_${this.dragState.direction}`
          : "";
      let start = columnIndex - 1 === this.dragState.start ? `darg_start` : "";
      return `${active} ${start}`;
    },
    cellClassName({ columnIndex }) {
      return columnIndex - 1 === this.dragState.start ? `darg_start` : "";
    },

    renderHeader(createElement, { column, $index }) {
      return createElement(
        "div",
        {
          class: ["thead-cell"],
          style: {
            height: "100%",
          },
          on: {
            mousedown: ($event) => {
              this.handleMouseDown($event, column);
            },
            mousemove: ($event) => {
              this.handleMouseMove($event, column);
            },
            dblclick: ($event) => {
              console.log($event);
              console.log(column);
              console.log(column.property);
              this.xiaojiFunc(column.property);
            },
          },
        },

        [
          // 添加 <a> 用于显示表头 label
          // createElement("a", column.label), // 添加一个空标签用于显示拖动动画
          createElement(
            "div",
            {
              class: "flex flex-column",
            },
            [
              createElement(
                "div",
                {
                  class: "flex item-center",
                  style: "height:30px",
                  on: {
                    click: ($event) => {
                      console.log("3333");
                      console.log(column.label);
                    },
                  },
                },
                [
                  <div style="max-width: 140px;">{column.label}</div>,
                  // createElement(
                  //   "el-popover",
                  //   {
                  //     props: {
                  //       placement: "top-start",
                  //       width: "200",
                  //       trigger: "hover",
                  //       content:
                  //         "拖拽切换信息位置，点击“x”删除信息，删除后的信息会在未添加表头内显示",
                  //     },
                  //     class: "flex item-center flex-center mr10",
                  //     style: {
                  //       zIndex: 1111,
                  //     },
                  //   },
                  //   [
                  //     createElement(
                  //       "div",
                  //       {
                  //         slot: "reference",
                  //         class: ["add-wrapper delete-tab flex flex-center"],
                  //         style: {
                  //           marginTop: "0px",
                  //         },
                  //       },

                  //       [
                  //         createElement("span", {
                  //           class: ["hmicon icon-guanbi1 pointer "],
                  //           style: {
                  //             fontSize: "13px",
                  //           },
                  //           on: {
                  //             click: ($event) => {
                  //               this.del($event, column);
                  //             },
                  //           },
                  //         }),
                  //       ]
                  //     ),
                  //   ]
                  // ),
                  createElement("div", [
                    createElement(
                      "el-select",
                      {
                        props: {
                          value: this.s_value,
                          filterable: true,
                        },
                        style: {
                          // zIndex: 1111,
                          zIndex: 2,
                        },
                        on: {
                          change: (value) => {
                            // value
                            console.log(value);
                            console.log($index);
                            // index
                            console.log(column.columnKey);
                            console.log(column);
                            // column.fixed = "left"
                            if (value == "hide") {
                              this.tableHeader.forEach((el, idx, arr) => {
                                if (idx == column.columnKey) {
                                  arr[idx].isShow = false;
                                }
                              });
                              // this.del(null, column);
                            }
                            if (value == "ascending") {
                              this.ascending(column.property);
                            }
                            if (value == "descending") {
                              // this.tableHeader.forEach((el, idx, arr) => {
                              //   if (idx == column.columnKey) {
                              //     arr[idx]["sort-orders"] = [
                              //       "descending",
                              //       "ascending",
                              //       null,
                              //     ];
                              //   }
                              // });
                              this.descending(column.property);
                            }
                            if (
                              value == "left" ||
                              value == "right" ||
                              value == false
                            ) {
                              column.fixed = value;
                              this.tableHeader.forEach((el, idx, arr) => {
                                if (idx == column.columnKey) {
                                  arr[idx].fixed = value;
                                }
                              });
                            }

                            // console.log(this.tableHeader);
                            this.$emit("delHeader", this.tableHeader);
                          },
                        },
                      },
                      [
                        createElement("el-option", {
                          props: {
                            value: "ascending",
                            label: "升序",
                            key: "ascending",
                          },
                        }),
                        createElement("el-option", {
                          props: {
                            value: "descending",
                            label: "降序",
                            key: "descending",
                          },
                        }),
                        createElement("el-option", {
                          props: {
                            value: "hide",
                            label: "隐藏当前列",
                            key: "hide",
                          },
                        }),
                        createElement("el-option", {
                          props: {
                            value: "left",
                            label: "固定在左边",
                            key: "toLeft",
                          },
                        }),
                        createElement("el-option", {
                          props: {
                            value: "right",
                            label: "固定在右边",
                            key: "toRight",
                          },
                        }),
                        createElement("el-option", {
                          props: {
                            value: false,
                            label: "取消固定",
                            key: "false",
                          },
                        }),
                      ]
                    ),
                  ]),
                ]
              ),
              // createElement("div", [
              //   createElement(
              //     "el-tooltip",
              //     {
              //       props: {
              //         placement: "bottom-end",
              //         content: "快捷筛选文本内容",
              //       },
              //       style: {
              //         zIndex: 1111,
              //       },
              //     },
              //     [
              //       createElement("i", {
              //         class: ["el-icon-info"],
              //         // style: {
              //         //   position: "absolute",
              //         //   top: "37px",
              //         //   left: "0"
              //         // }
              //       }),
              //     ]
              //   ),
              // ]),
              <div style="height:50px;">
                <el-input
                  clearable
                  class="column-input"
                  style="width:150px; padding:0; margin:0"
                  size="small"
                  placeholder=""
                  onInput={this.query(column)}
                  v-model={column.filterPlacement}
                />
              </div>,
            ]
          ),
          // createElement("span", {
          //   class: ["virtual"],
          // }),

          // createElement(
          //   "el-tooltip",
          //   {
          //     props: {
          //       placement: "bottom-end",
          //       content: "快捷筛选文本内容"
          //     },
          //     style: {
          //       zIndex: 1111
          //     }
          //   },
          //   [
          //     createElement("i", {
          //       class: ["el-icon-info"],
          //       style: {
          //         position: "absolute",
          //         top: "37px",
          //         left: "0"
          //       }
          //     })
          //   ]
          // )
          // createElement("i", {
          //   class: ["el-icon-info"],
          //   style: {
          //     position: "absolute",
          //     top: "47px",
          //     left: "0"
          //   }
          // })
          // createElement(
          //   "el-tooltip",
          //   {
          //     props: {
          //       placement: "top-start",
          //       width: "200",
          //       trigger: "hover",
          //       content: "3333"
          //     },
          //     style: {
          //       zIndex: 1111
          //     }
          //   },
          //   [
          //     createElement("i", {
          //       slot: "reference",
          //       class: ["el-icon-info"]
          //     })
          //   ]
          // )

          // <div>
          //   <el-input
          //     clearable
          //     style="width:150px"
          //     size="small"
          //     placeholder=""
          //     onInput={this.query(column)}
          //     v-model={column.filterPlacement}
          //   />
          // </div>
        ]
      );
    },
    query(column) {
      // console.log("column: ", column);
      // console.log("this.data: ", this.data);

      if (this.data.length) {
        if (column.filterPlacement) {
          setTimeout(() => {
            this.filterFunc(column.property, column.filterPlacement);
          }, 1000);
        } else {
          this.tableData = JSON.parse(JSON.stringify(this.data));
        }
        // this.falg = false;
        // this.tableHeader.forEach(v => {
        //   if (v.filterPlacement !== "") {
        //     this.falg = true;
        //   }
        // });
      }
    },
    filterFunc(property, val) {
      this.tableData = [];
      this.data.filter((v) => {
        let svc = v[property].toString();
        // console.log("svc: ", svc);
        // console.log(
        //   'v[property] + "".search(val + ""): ',
        //   svc.search(val + "")
        // );
        if (svc.search(val + "") > -1) {
          this.tableData.push(v);
        }
      });
      console.log("this.tableData: ", this.tableData);
      // this.$emit("setTableData", this.tableData);

      // this.$forceUpdate();

      // if (this.falg) {
      // } else {
      //   this.tableData = JSON.parse(JSON.stringify(this.data));
      // }
    },
    // 升序
    ascending(property) {
      // console.log('descending')
      // console.log(this.tableData)
      if (this.data.length) {
        this.tableData = this.data.sort((a, b) => {
          return a[property] - b[property];
        });
        console.log(this.tableData);
      }
    },
    // 降序
    descending(property) {
      // console.log('descending')
      // console.log(this.tableData)
      if (this.data.length) {
        this.tableData = this.data.sort((a, b) => {
          return b[property] - a[property];
        });
        console.log(this.tableData);
      }
    },
    del(e, column) {
      // this.transitionShowTiem();
      // setTimeout(() => {
      this.tableHeader.splice(+column.columnKey, 1);
      this.$emit("delHeader", this.tableHeader);
      // }, 500);
    },
    // 按下鼠标开始拖动
    handleMouseDown(e, column) {
      this.dragState.dragging = true;
      this.dragState.start = parseInt(column.columnKey);
      // 给拖动时的虚拟容器添加宽高
      let table = document.getElementsByClassName("w-table")[0];
      let virtual = document.getElementsByClassName("virtual");
      for (let item of virtual) {
        item.style.height = table.clientHeight - 1 + "px";
        item.style.width = item.parentElement.parentElement.clientWidth + "px";
      }
      document.addEventListener("mouseup", this.handleMouseUp);
    },

    // 鼠标放开结束拖动
    handleMouseUp() {
      this.dragColumn(this.dragState);
      // 初始化拖动状态
      this.dragState = {
        start: -9,
        end: -9,
        dragging: false,
        direction: undefined,
      };
      document.removeEventListener("mouseup", this.handleMouseUp);
    },

    // 拖动中
    handleMouseMove(e, column) {
      if (this.dragState.dragging) {
        let index = parseInt(column.columnKey); // 记录起始列
        if (index - this.dragState.start !== 0) {
          this.dragState.direction =
            index - this.dragState.start < 0 ? "left" : "right"; // 判断拖动方向
          this.dragState.end = parseInt(column.columnKey);
        } else {
          this.dragState.direction = undefined;
        }
      } else {
        return false;
      }
    },

    // 拖动易位
    dragColumn({ start, end, direction }) {
      let tempData = [];
      let left = direction === "left";
      let min = left ? end : start - 1;
      let max = left ? start + 1 : end;
      for (let i = 0; i < this.tableHeader.length; i++) {
        if (i === end) {
          tempData.push(this.tableHeader[start]);
        } else if (i > min && i < max) {
          tempData.push(this.tableHeader[left ? i - 1 : i + 1]);
        } else {
          tempData.push(this.tableHeader[i]);
        }
      }

      this.tableHeader = tempData;

      console.log(tempData);
      this.$emit("dragHeader", this.tableHeader);
    },
    // 数组排序
    compare(key) {
      return function (obj1, obj2) {
        var val1 = obj1[key];
        var val2 = obj2[key];
        if (val1 < val2) {
          return -1;
        } else if (val1 > val2) {
          return 1;
        } else {
          return 0;
        }
      };
    },
    // 小记
    xiaojiFunc(property) {
      console.log(property);
      this.xiaojiFlag = !this.xiaojiFlag;
      if (this.xiaojiFlag) {
        let arrs = this.tableXiaoji;
        let data = this.tableData;
        // 排序
        data = data.sort(this.compare(property));
        // console.log("xiaoji", arrs);
        data.forEach((v) => {
          v.rowspan = 1;
        });
        // console.log("data", data);
        // 双层循环
        for (let i = 0; i < data.length; i++) {
          // 内层循环，上面已经给所有的行都加了v.rowspan = 1
          // 这里进行判断
          // 如果当前行的id和下一行的id相等
          // 就把当前v.rowspan + 1
          // 下一行的v.rowspan - 1
          for (let j = i + 1; j < data.length; j++) {
            //此处可根据相同字段进行合并，此处是根据的id
            if (data[i][property] === data[j][property]) {
              data[i].rowspan++;
              data[j].rowspan--;
            }
          }
          // 这里跳过已经重复的数据
          i = i + data[i].rowspan - 1;
        }
        let array = [];
        let countItem = {};
        arrs.forEach((v) => {
          countItem[v] = 0;
        });
        console.log("countItem", countItem);
        for (let i = 0; i < data.length; i++) {
          array.push(data[i]);
          for (let key in data[i]) {
            for (let countKey in countItem) {
              if (key == countKey) {
                countItem[countKey] += data[i][key];
                // countItem[countKey] = countItem[countKey].toFixed(2)
              }
            }
          }
          if (i + 1 < data.length) {
            let item = data[i + 1];
            console.log("item", item);
            if (item.rowspan > 0) {
              let it = { [property]: "小计" };
              for (let key in data[i]) {
                for (let countKey in countItem) {
                  if (key == countKey) {
                    it[countKey] = parseFloat(countItem[countKey]).toFixed(2);
                  }
                }
              }
              array.push(it);
              for (let countKey in countItem) {
                countItem[countKey] = 0;
              }
            }
          } else if (i + 1 == data.length) {
            let it = { [property]: "小计" };
            for (let key in data[i]) {
              for (let countKey in countItem) {
                if (key == countKey) {
                  it[countKey] = countItem[countKey];
                }
              }
            }
            array.push(it);
          }
        }
        // console.log(array);
        this.tableData = array;
      } else {
        this.tableData = this.tableRawData;
      }
    },
    search() {
      if (this.tableHeader.length) {
        this.queryAnalyzeList();
      } else {
        this.$message({
          message: "请添加表头",
          type: "warning",
        });
      }
    },
    async getTableData(tableId) {
      this.loading = true;
      try {
        const { code, result } = await this.$store.dispatch(
          "querySsrAnalysisQueueDetail",
          {
            queueId: tableId,
          }
        );
        this.loading = false;
        if (code === "0") {
          if (!result) {
            this.getTableData(tableId);
            return;
          }
          let tableDatas = JSON.parse(result.responseResultContent);
          tableDatas = tableDatas.slice(0, 200);
          this.$emit("setTableData", tableDatas);
        }
      } catch (error) {
        this.loading = false;
      }
    },
    async queryAnalyzeList() {
      let whereColumns = [];
      let selectColumns = [];
      let groupColumns = [];
      let falg = false;
      this.tableConditions.forEach((v) => {
        if (v.isRequiredWhere === "yes") {
          if (v.columnType === "datetime") {
            if (v.queryMode === "range") {
              if (v.applyDate === null || v.applyDate.length === 0) {
                falg = true;
              } else {
                whereColumns.push(v);
              }
            } else {
              if (v.queryValue === "") {
                falg = true;
              } else {
                whereColumns.push(v);
              }
            }
          } else {
            if (v.isMultiple) {
              if (v.queryListValue.length === 0) {
                falg = true;
              } else {
                whereColumns.push(v);
              }
            } else {
              if (v.queryValue === "") {
                falg = true;
              } else {
                whereColumns.push(v);
              }
            }
          }
        } else {
          if (v.columnType === "datetime") {
            if (v.queryMode === "range") {
              if (v.applyDate === null || v.applyDate.length === 0) {
                // falg = false;
              } else {
                whereColumns.push(v);
              }
            } else {
              if (v.queryValue === "") {
                // falg = false;
              } else {
                whereColumns.push(v);
              }
            }
          } else {
            if (v.isMultiple) {
              if (v.queryListValue.length === 0) {
                // falg = false;
              } else {
                whereColumns.push(v);
              }
            } else {
              if (v.queryValue === "") {
                // falg = false;
              } else {
                whereColumns.push(v);
              }
            }
          }
        }
      });
      if (falg) {
        this.$message({
          message: "请填写完必填项",
          type: "warning",
        });
      } else {
        let show = false;
        this.col.forEach((v) => {
          if (v.isAggregateColumn === "yes") {
            show = true;
          }
        });
        if (show) {
          this.col.forEach((v) => {
            if (v.isAggregateColumn !== "yes") {
              groupColumns.push(v);
            }
          });
          selectColumns = JSON.parse(JSON.stringify(this.tableHeader));
        } else {
          selectColumns = JSON.parse(JSON.stringify(this.tableHeader));
          // this.col.forEach(v => {
          //   if (v.isSelectColumn === "yes") {
          //     selectColumns.push(v);
          //   }
          //   if (v.isGroupColumn === "yes") {
          //     groupColumns.push(v);
          //   }
          // });
        }

        // if (this.tableHeader === "table") {
        //   selectColumns = JSON.parse(JSON.stringify(this.col));
        //   groupColumns = [];
        // } else {
        //   groupColumns = JSON.parse(JSON.stringify(this.col));
        //   selectColumns = JSON.parse(JSON.stringify(this.tableGroup));
        // }

        // let selectColumns = JSON.parse(JSON.stringify(this.col));
        // let groupColumns = JSON.parse(JSON.stringify(this.col));
        whereColumns.forEach((v) => {
          if (v.queryMode === "range") {
            if (v.columnType === "datetime") {
              v.queryStartValue = v.applyDate[0];
              v.queryEndValue = v.applyDate[1];
            }
          }
        });
        // this.tableHeader
        // this.tableConditions
        let tableHeader = {
          tableHeader: this.tableHeader,
          AllHeader: this.tableList,
        };
        let params = {
          id: this.$route.query.id,
          whereColumns,
          selectColumns,
          groupColumns,
          tableHeader: JSON.stringify(tableHeader),
          queryCondition: JSON.stringify(this.tableConditions),
        };
        this.loading = true;
        const { result, code } = await this.$store.dispatch(
          "queryAnalyzeList",
          params
        );
        if (code === "0") {
          this.loading = false;
          this.$message({
            message: "报表正在生成中，1分钟内生成结果！",
            type: "success",
            duration: 10000,
            showClose: true,
          });
          this.getTableData(result);
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ th{
  position: relative;
}
/deep/ .el-select{
  // position: absolute;
  // right: 60px;
  // top: -10px;
  width: 30px;
  z-index: 666;
}
/deep/ .el-select .el-input{
  width: 60px !important;
}
/deep/ .el-select .el-input input {
  width: 0;
  border: none;
  padding: 0;
}
.w-table {
  .el-select {
    // width: 28px;
    width: 50px;
  }
  //   border: 1px solid #ebeef5;
  //   border-bottom: none;
  .el-table .darg_start {
    background-color: #f3f3f3;
  }
  .el-table th {
    padding: 0;
    .virtual {
      position: fixed;
      display: block;
      width: 0;
      height: 0;
      margin-left: -10px;
      background: none;
      border: none;
    }
    &.darg_active_left {
      .virtual {
        border-left: 2px dotted #666;
        z-index: 99;
      }
    }
    &.darg_active_right {
      .virtual {
        border-right: 2px dotted #666;
        z-index: 99;
      }
    }
  }
  .thead-cell {
    padding: 0;
    // min-width: 120px;
    line-height: 30px;
    // display: inline-flex;
    // height: 80px;
    // flex-direction: column;
    // align-items: left;
    cursor: pointer;
    overflow: initial;
    &:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
    }
    .delete-tab {
      //   position: absolute;
      //   top: 50%;
      //     left: ;
      //   margin-top: -10px;
      z-index: 999;
      margin-top: 0px;
      width: 20px;
      height: 20px;
      line-height: 20px;
      background: #e50065;
      color: #fff;
      text-align: center;
      border-radius: 50%;
      margin-left: 10px;
      &.hmicon {
        font-size: 12px;
      }
    }
  }
  &.w-table_moving {
    .el-table th .thead-cell {
      cursor: move !important;
    }
    .el-table__fixed {
      cursor: not-allowed;
    }
  }
  .el-loading-spinner {
    background-image: url("https://imgcdn.hemiao100.com/ThemePictures/reporting.gif"); // 这个是自己想设置的 gif 加载动图
    background-repeat: no-repeat; //设置背景 图 不重复
    height: 100%;
    background-position: center; //设置背景 定位  为居中
    top: 0; //覆盖 element-ui  默认的 50%    因为此处设置了height:100%,所以不设置的话，会只显示一半，因为被top顶下去了
  }
  .el-loading-spinner .circular {
    display: none; //隐藏 之前  element-ui  默认的 loading 动画
  }
  // .column-input {
    // margin-bottom: 6px !important;
    // margin-top: 10px !important;
  // }
}
</style>
<style lang="scss" scoped>
.chart-header {
  background: #fff;
  padding: 15px;
  .module-name {
    font-size: 16px;
    font-weight: bold;
    line-height: 30px;
  }
  .sub-title {
    font-size: 14px;
  }
}
.table_options {
  position: fixed;
  top: 0;
  right: 0;
  width: 40px;
  height: 92px;
  background-color: #fff;
}
</style>
